export const tokenProfileHeaderBreakpoints = {
  // breakpoint to have mobile links
  mobileLinks: '(max-width: 931px)',
};
